export const ieo = {
    zzjx: "Devam Ediyor",
    rgjl: "Satın Alma Geçmişi",
    yjjs: "Sonlanmış",
    sf: "İlk Çıkış",
    mjze: "Toplam Fon Miktarı",
    ckjz: "Fon Toplama Durumu",
    tips_1: "Biking Startup platformu büyük bir lansmanla çıkıyor, Biking ile birlikte zenginliğin şifresini keşfedin!",
    tips_2: "Yakında yüksek kaliteli projeler gelecek, heyecanla bekleyin",
    jyjjks: "İşlemler Yakında Başlayacak",
    ksjy: "İşleme Başla",
    qjy: "İşleme Git",
    xmmc: "Proje Adı",
    xmfjs: "Proje Ekibi Tanıtımı",
    syxm: "Tüm Projeler",
    banner_1: "Blokzincir Proje İlk Çıkış Platformunu Yeni Sunar",
    banner_2: "Biking ile birlikte blokzincirin karanlık atlarını arayın ve finansal özgürlük yolunu açın",
    ywc: "Tamamlandı",
    rgsj: "Satın Alma Zamanı:",
    zcz: "Destekçiler",
    dqjd: "Mevcut İlerleme",
    yck: "Toplanan Fon",
    sddb: "Alınan Tokenlar",
    dff: "Dağıtım Bekleniyor",
    zwxm: "Henüz Proje Yok",
    xq: "Detaylar",
    wksyr: "Ön Isınma Başlamadı",
    yrz: "Ön Isınma Devam Ediyor",
    jxz: "Devam Ediyor",
    yjs: "Sonlanmış",
    ts: "Uyarı",
    dbwfjy: "Bu token şu anda işlem göremiyor",
    ckqtdb: "Lütfen diğer tokenları kontrol edin",
    xm: "Proje",
    ksrg: "Satın Alma Başla",
    yrg: "Satın Alındı",
    xmjs: "Proje Tanıtımı",
    csjg: "Başlangıç Fiyatı",
    dbzl: "Toplam Token Arzı: {amount} adet",
    cssz: "Başlangıç Piyasa Değeri: {fdv} ABD Doları",
    xmcytj: "Proje Katılım Koşulları",
    cjygzh: "Bir Biking Hesabı Oluşturun",
    yyzh: "Zaten hesabım var, doğrudan giriş yap",
    dlzhjkcy: "Hesabınıza giriş yaparak satın almaya katılabilirsiniz",
    dljkrg: "Hesabınıza giriş yaparak satın alabilirsiniz",
    xhzc: "Spot Varlıklar",
    zcdy: "Spot Varlıklar ≥ 10 USDT",
    rggz: "Satın Alma Kuralları",
    rgcg: "Satın Alma Başarılı",
    cgrgxm: "Tebrikler! Projeyi başarıyla satın aldınız!",
    fhsy: "Ana Sayfaya Dön",
    cyrghd: "Biking Startup Satın Alma Etkinliğine Katılın",
    rgje: "Satın Alma Miktarı",
    xhzcgz: "Spot Varlık Değerlemesi",
    rgsm: "Satın Alma Açıklaması:",
    rgsm1: "1. Kişisel satın alma miktarı ≥{amount1}USDT; ≤{amount2}USDT;",
    rgsm2: "2. Projeler, fon yatırım oranına göre eşit oranda dağıtılır, eğer kullanıcının satın alma miktarı fiilen dağıtılan token miktarından fazla ise, satın alma sona erdikten sonra kalan USDT nakit hesaba iade edilir",
    qd: "Onayla",
    dyr: "Ön Isınma Bekleniyor",
    rgdjs: "Satın Alma Geri Sayımı",
    yrdjs: "Ön Isınma Geri Sayımı",
    jykqdjs: "İşlem Açılış Geri Sayımı",
    qrg: "Satın Almaya Git",
    rgjebdy: "Satın alma miktarı en az {amount} USDT olmalıdır",
    rgjebgy: "Satın alma miktarı en fazla {amount} USDT olabilir",
    rgjeccdqjc: "Satın alma miktarı mevcut varlık miktarını aşıyor",
    fxts1: "1. Startup projeler hala erken aşamadadır, projenin operasyonları, altyapı teknolojisi, yasal ve düzenleyici ortam vb. konularda büyük riskler olabilir.",
    fxts2: "2. Token'ı anlamak ve doğal risklerini değerlendirmek için ileri teknik ve finansal bilgi gereklidir.",
    fxts3: "3. Teknoloji, yasa ve düzenlemeler, piyasa ve diğer faktörlerden etkilenerek, satın aldığınız Token'ın fiyatı sert dalgalanmalar gösterebilir, fiyat önemli ölçüde düşebilir veya yükselebilir.",
    fxts4: "4. Token'ın altyapı teknolojisi veya BIKING borsa platformu nedeniyle, satın aldığınız Token'ın tamamı veya bir kısmı çekilemeyebilir.",
    sfpt: "Blokzincir Proje İlk Çıkış Platformu",
    xmhzsq: "Proje İşbirliği Başvurusu",
    hdlx: "Etkinlik Türü",
    yryq: "Kişi Başına Bir Çekiliş",
    yrdq: "Kişi Başına Birden Fazla Çekiliş",
    hdjg: "Etkinlik Fiyatı",
    hdsl: "Etkinlik Miktarı",
    zqs: "Toplam Çekiliş Sayısı",
    rgqs: "Satın Alma Çekiliş Sayısı",
    rgsl: "Satın Alma Miktarı",
    mqsl: "Çekiliş Başına Miktar",
    mrzgqs: "Kişi Başına Maksimum Çekiliş Sayısı",
    qian: "Çekiliş",
    lian: "Zincir",
    hdrgsm: "Satın Alma Açıklaması: Çekiliş kazandıktan sonra satın alma yapılır, tüm kazanan kullanıcılar arasından toplam kazanan sayısı kadar kullanıcı rastgele seçilir. Eğer satın alma başarısız olursa, kazananlara airdrop dağıtılırken başarısız satın alma için kullanılan USDT iade edilir.",
    jqqd: "Çekiliş Sonucunu Heyecanla Bekleyin",
    dbffkjy: "Tokenlar dağıtıldıktan sonra işlem görebilir",
    dzjgb: "Çekiliş Sonucu Bekleniyor",
    dzq: "Çekiliş Bekleniyor",
    ffzt: "Dağıtım Durumu",
    dbff: "Kazanan Token Dağıtımı",
    yff: "Dağıtıldı",
    wzq: "Kazanamadı"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/tr.js